<div class="d-flex flex-column h-100">
  <mat-toolbar>
    <div class="d-flex flex-column">
      <span class="font-weight-bold">Permit: View / Edit</span>
    </div>
    <span class="filler"></span>
    <div class="d-flex justify-content-end">
      <button mat-icon-button aria-label="pdf preview" matTooltip="Download PDF Permit(s)">
        <mat-icon fontSet="far" fontIcon="fa-file-pdf"></mat-icon>
      </button>
      <button mat-icon-button (click)="showPermitSearchDialog()" aria-label="Permit search button" matTooltip="Search Permit" class="ml-2">
        <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-tab-group class="ns-mat-tab-group overflow-auto flex-grow-1" animationDuration="0ms">
    <mat-tab *ngFor="let permit of permits; trackBy: trackById">
      <ng-template mat-tab-label>
        {{ permit.title }}
        <button mat-button (click)="emitRemovePermit(permit)" *ngIf="permits.length > 1">
          <mat-icon class="h-auto" fontSet="fas" fontIcon="fa-times"></mat-icon>
        </button>
      </ng-template>
      <div class="h-100 p-2">
        <ng-container [ngTemplateOutlet]="permit.permitType === 'E' ? emptyPermitTemplate : loadPermitTemplate"
                      [ngTemplateOutletContext]="{ permit: permit }">
        </ng-container>
      </div>
    </mat-tab>
    <mat-tab disabled>
      <ng-template mat-tab-label>
        <button mat-mini-fab (click)="emitAddPermit()" matTooltip="Add Permit" aria-label="add permit">
          <mat-icon class="w-auto h-auto" fontSet="fas" fontIcon="fa-plus"></mat-icon>
        </button>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-template #loadPermitTemplate let-permit='permit'>
  <ng-permit-container [name]="permit.name"></ng-permit-container>
</ng-template>
<ng-template #emptyPermitTemplate let-permit='permit'>
  <ng-empty-permit-container [permit]="permit"></ng-empty-permit-container>
</ng-template>
